<template>
    <div>
        <!--  BEGIN NAVBAR  -->
        <div class="header-container fixed-top">
            <header class="header navbar navbar-expand-sm">
                <ul class="navbar-item theme-brand flex-row text-center">
                    <li class="nav-item theme-logo">
                        <router-link to="/">
                            <img src="@/assets/images/logo.svg" class="navbar-logo" alt="logo" />
                        </router-link>
                    </li>
                    <li class="nav-item theme-text">
                        <router-link to="/" class="nav-link"> Lance Fácil </router-link>
                    </li>
                </ul>
                <div class="d-none horizontal-menu">
                    <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom"
                        @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="feather feather-menu">
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    </a>
                </div>

                <!-- Motores de sincronização: continuam independentes e montados; só publicam o estado (useSyncStatus) -->
                <div hidden>
                    <syncpregoes v-if="atvSyncPreg == 1 && msgAcaoPregao == ''" />
                    <syncalertas v-if="atvSyncChat == 1 && msgAcaoAlerta == ''" />
                    <syncalertasbnc :idPortal="5" v-if="atvSyncChatBLL == 1 && msgAcaoAlertaBLL == ''" />
                    <syncalertasbnc :idPortal="8" v-if="atvSyncChatBNC == 1 && msgAcaoAlertaBNC == ''" />
                </div>

                <!-- Card único: estado geral das sincronizações; passando o mouse/clicando mostra o detalhe de cada uma -->
                <ul class="navbar-item flex-row ms-3">
                    <li class="nav-item align-self-center">
                        <StatusSyncPortais :avisos="avisosSync" />
                    </li>
                    <!-- Alerta fixo até o e-mail da conta ser confirmado -->
                    <li class="nav-item align-self-center ms-2">
                        <EmailContaAviso />
                    </li>
                </ul>

                <div class="navbar-item flex-row ms-md-auto">
                    <!-- Multi-CNPJ: seletor da empresa ativa -->
                    <EmpresaAtivaSelect />

                    <!-- Nova versao publicada: o mesmo botao do rodape, aqui para quem esta com a pagina rolada e nao ve o rodape -->
                    <div v-if="updateAvailable" class="nav-item align-self-center me-2">
                        <button type="button" class="btn btn-primary btn-sm"
                            style="font-size: 12px; font-weight: 600; letter-spacing: 0.5px; padding: 3px 14px; white-space: nowrap;"
                            title="Nova versão disponível. Clique para recarregar." @click="recarregar">
                            Atualizar app
                        </button>
                    </div>

                    <div class="nav-item btn-group">
                        <a href="javascript:;" id="ddlnewmsgs" class="btn btn-icon-only nav-link" @click="goAlertas()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-message-circle">
                                <path
                                    d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z">
                                </path>
                            </svg>
                            <span v-if="syncStatus.qntAlertasNaoLidos > 0" class="badge badge-danger counter">{{
                                syncStatus.qntAlertasNaoLidos }}</span>
                        </a>
                    </div>

                    <!-- Sino de notificações in-app -->
                    <div class="nav-item" style="margin-left: 10px;">
                        <NotificacoesSino />
                    </div>

                    <!-- Megafone: novidades/comunicados do sistema (Painel de News) -->
                    <div class="nav-item" style="margin-left: 10px;">
                        <NewsMegafone />
                    </div>

                    <!-- "?" da página: abre o artigo de ajuda da tela atual -->
                    <div class="nav-item d-flex" style="margin-left: 10px;">
                        <AjudaPagina variante="nav" />
                    </div>

                    <div class="dropdown nav-item" style="margin-left: 10px;">
                        <a href="javascript:;" id="ddlopcs" data-bs-toggle="dropdown" aria-expanded="false"
                            class="btn btn-icon-only nav-link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="">
                                <circle cx="12" cy="12" r="3"></circle>
                                <path
                                    d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z">
                                </path>
                            </svg>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ddluser">
                            <li role="presentation" class="px-3 pb-1 text-end">
                                <AjudaBotao :slug="AJUDA_SLUGS.SISTEMA_APARENCIA_MENU" variante="popup" titulo="Ajuda: tema e estilo do menu" />
                            </li>
                            <li role="presentation">
                                <a v-if="$store.state.dark_mode == 'light'" href="javascript:;" class="dropdown-item"
                                    @click="toggleMode('dark')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="feather feather-sun">
                                        <circle cx="12" cy="12" r="5"></circle>
                                        <line x1="12" y1="1" x2="12" y2="3"></line>
                                        <line x1="12" y1="21" x2="12" y2="23"></line>
                                        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                                        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                                        <line x1="1" y1="12" x2="3" y2="12"></line>
                                        <line x1="21" y1="12" x2="23" y2="12"></line>
                                        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                                        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                                    </svg>
                                    <span class="ms-2">Claro</span>
                                </a>
                                <a v-if="$store.state.dark_mode == 'dark'" href="javascript:;" class="dropdown-item"
                                    @click="toggleMode('light')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="feather feather-moon">
                                        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                                    </svg>
                                    <span class="ms-2">Escuro</span>
                                </a>
                            </li>
                            <li role="presentation">
                                <a href="javascript:;" @click="setMenuStyle('vertical')" class="dropdown-item">
                                    <svg width="24px" height="24px" viewBox="0 0 0.72 0.72" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0.12 0.21a0.03 0.03 0 0 1 0.03 -0.03h0.42a0.03 0.03 0 1 1 0 0.06H0.15a0.03 0.03 0 0 1 -0.03 -0.03m0 0.15a0.03 0.03 0 0 1 0.03 -0.03h0.42a0.03 0.03 0 1 1 0 0.06H0.15a0.03 0.03 0 0 1 -0.03 -0.03m0 0.15a0.03 0.03 0 0 1 0.03 -0.03h0.42a0.03 0.03 0 1 1 0 0.06H0.15a0.03 0.03 0 0 1 -0.03 -0.03"
                                            fill="#0D0D0D" />
                                    </svg> Menu vertical
                                </a>
                            </li>
                            <li role="presentation">
                                <a href="javascript:;" @click="setMenuStyle('collapsible-vertical')"
                                    class="dropdown-item">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="feather feather-align-left">
                                        <line x1="17" y1="10" x2="3" y2="10"></line>
                                        <line x1="21" y1="6" x2="3" y2="6"></line>
                                        <line x1="21" y1="14" x2="3" y2="14"></line>
                                        <line x1="17" y1="18" x2="3" y2="18"></line>
                                    </svg>
                                    Menu vertical recolhido
                                </a>
                            </li>
                            <li role="presentation">
                                <a href="javascript:;" @click="setMenuStyle('horizontal')" class="dropdown-item">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px"
                                        viewBox="0 0 1.92 1.92" enable-background="new 0 0 64 64" xml:space="preserve">
                                        <path fill="none" stroke="#000000" stroke-width="0.06" stroke-linejoin="bevel"
                                            stroke-miterlimit="10" points="8,25 1,32 8,39 "
                                            d="M0.24 0.75L0.03 0.96L0.24 1.17" />
                                        <path fill="none" stroke="#000000" stroke-width="0.06" stroke-linejoin="bevel"
                                            stroke-miterlimit="10" points="56,39 63,32 56,25 "
                                            d="M1.68 1.17L1.89 0.96L1.68 0.75" />
                                        <path fill="none" stroke="#000000" stroke-width="0.06" stroke-miterlimit="10"
                                            points="63,32 43,32 1,32 " d="M1.89 0.96L1.29 0.96L0.03 0.96" />
                                    </svg> Menu horizontal
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="dropdown nav-item user-profile-dropdown btn-group">
                        <a href="javascript:;" id="ddluser" data-bs-toggle="dropdown" aria-expanded="false"
                            class="btn dropdown-toggle btn-icon-only user nav-link">
                            <img src="@/assets/images/no-image-profile.jpg" alt="avatar" />
                        </a>
                        <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ddluser">
                            <li role="presentation">
                                <router-link to="/users/profile" class="dropdown-item">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="feather feather-user">
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="12" cy="7" r="4"></circle>
                                    </svg>
                                    Perfil
                                </router-link>
                            </li>
                            <li role="presentation">
                                <a href="javascript:;" @click="trancaTela()" class="dropdown-item">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="feather feather-lock">
                                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                    </svg>
                                    Trancar tela
                                </a>
                            </li>
                            <li role="presentation">
                                <a href="javascript:;" @click="lofogUser()" class="dropdown-item">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="feather feather-log-out">
                                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                        <polyline points="16 17 21 12 16 7"></polyline>
                                        <line x1="21" y1="12" x2="9" y2="12"></line>
                                    </svg>
                                    Sair do sistema
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

            </header>
        </div>
        <!--  END NAVBAR  -->

        <!--  BEGIN NAVBAR  -->
        <div class="sub-header-container">
            <header class="header navbar navbar-expand-sm">
                <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom"
                    @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="feather feather-menu">
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </a>

                <!-- Breadcrumb gerado a partir do route.meta.breadcrumbs -->
                <ul class="navbar-nav flex-row" v-if="breadcrumbs.length">
                    <li>
                        <div class="page-header">
                            <nav class="breadcrumb-one">
                                <ol class="breadcrumb">
                                    <li v-for="(bc, i) in breadcrumbs.slice(0, -1)" :key="i" class="breadcrumb-item">
                                        <a href="javascript:;">{{ bc }}</a>
                                    </li>
                                    <li class="breadcrumb-item active">
                                        <span>{{ breadcrumbs[breadcrumbs.length - 1] }}</span>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </li>
                </ul>
                <!-- Alvo oculto mantido para compatibilidade com teleports nas views -->
                <div id="breadcrumb" style="display:none"></div>
            </header>
        </div>
        <!--  END NAVBAR  -->

        <!--  BEGIN TOPBAR  -->
        <div class="topbar-nav header navbar" role="banner">
            <nav class="topbar">
                <ul class="list-unstyled menu-categories" id="topAccordion">
                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle autodroprown">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-home">
                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                                </svg>
                                <span>Dashboard</span>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-down">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li v-for="item in dashboardItems" :key="item.to">
                                <router-link :to="item.to"><span class="menu-rotulo" v-dica-truncada>{{ item.label }}</span></router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-search">
                                    <circle cx="11" cy="11" r="8"></circle>
                                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                </svg>
                                <span>Busca de editais</span>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-down">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li><a href="javascript:;" @click="navegaBuscaOrFav(true)">Favoritos</a></li>
                            <li><a href="javascript:;" @click="navegaBuscaOrFav(false)">Buscar</a></li>
                            <li><router-link to="/apps/boletins"><span class="menu-rotulo" v-dica-truncada>Boletins</span></router-link></li>
                        </ul>
                    </li>

                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-layers">
                                    <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                                    <polyline points="2 17 12 22 22 17"></polyline>
                                    <polyline points="2 12 12 17 22 12"></polyline>
                                </svg>
                                <span>Minhas licitações</span>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-down">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li v-for="item in minhasLicItensVisiveis" :key="item.to">
                                <router-link :to="item.to"><span class="menu-rotulo" v-dica-truncada>{{ item.label }}</span></router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="menu single-menu">
                        <router-link to="/apps/alertas" class="menu single-menu dropdown-toggle" active-class="active"
                            exact-active-class="exact-active">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 448 512" fill="currentColor">
                                    <path
                                        d="M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4l0-25.4c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112l0 25.4c0 47.9 13.9 94.6 39.7 134.6L72.3 368C98.1 328 112 281.3 112 233.4l0-25.4c0-61.9 50.1-112 112-112zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z" />
                                </svg>
                                <span>Alertas</span>
                            </div>
                        </router-link>
                    </li>

                    <!-- Menu Lances — visível apenas quando lanceweb = 1 -->
                    <li class="menu single-menu" v-if="showLances">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-zap">
                                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                                </svg>
                                <span>Lances</span>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-down">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li v-for="item in lancesItems" :key="item.to">
                                <router-link :to="item.to"><span class="menu-rotulo" v-dica-truncada>{{ item.label }}</span></router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-settings">
                                    <circle cx="12" cy="12" r="3"></circle>
                                    <path
                                        d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z">
                                    </path>
                                </svg>
                                <span>Configurações</span>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-down">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li v-for="item in configItems" :key="item.to">
                                <router-link :to="item.to"><span class="menu-rotulo" v-dica-truncada>{{ item.label }}</span></router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-users">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="9" cy="7" r="4"></circle>
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>
                                <span>Usuário</span>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-down">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li v-for="item in usuarioItems" :key="item.to">
                                <router-link :to="item.to"><span class="menu-rotulo" v-dica-truncada>{{ item.label }}</span></router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-book">
                                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                                </svg>
                                <span>Ajuda</span>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-down">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li>
                                <a :href="urlDocumentacao" target="_blank" rel="noopener">Documentação</a>
                            </li>
                            <li>
                                <a href="javascript:;" @click="abrirRecursosPortais">Recursos disponíveis</a>
                            </li>
                            <li>
                                <a :href="linkAjuda" target="_blank" rel="noopener">Chat suporte</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </div>
        <!--  END TOPBAR  -->
        <RecursosPortaisModal />
        <audio ref="alerta" src="/sounds/icq-alert.mp3" preload="auto"></audio>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, computed, watch } from 'vue';
import { dashboardItems, minhasLicItems, lancesItems, configItems, usuarioItems, filtraItensMenu } from '@/config/menuNav';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import syncpregoes from '@/views/comps/syncpregoes.vue';
import syncalertas from '@/views/comps/syncalertas.vue';
import syncalertasbnc from '@/views/comps/syncalertasbnc.vue';
import StatusSyncPortais from '@/components/layout/StatusSyncPortais.vue';
import EmailContaAviso from '@/components/layout/EmailContaAviso.vue';
import NotificacoesSino from '@/components/layout/NotificacoesSino.vue';
import NewsMegafone from '@/components/layout/NewsMegafone.vue';
import EmpresaAtivaSelect from '@/components/layout/EmpresaAtivaSelect.vue';
import { getCnpjAtivo } from '@/mixins/empresaAtiva';
import { getConfigGeral as getConfigGeralApi, getDadosIniciais, listaConfigAlerta } from '@/stores/configsStore';
import { listaPortaisQueSincronizam } from '@/stores/portaisStore';
import RecursosPortaisModal from '@/components/layout/RecursosPortaisModal.vue';
import { montaLinkAjuda } from '@/config/ajuda';
import AjudaBotao from '@/components/AjudaBotao.vue';
import AjudaPagina from '@/components/AjudaPagina.vue';
import { AJUDA_SLUGS, montaUrlAjuda } from '@/config/ajudaEngage';
import { listaPlsAlertas } from '@/stores/alertasStore';
import eventBus from '@/views/eventBus';
import { useLicencaTipo, showAlert } from '@/mixins/fcgeral';
import { heartbeatData } from '@/mixins/heartbeat';
import { useAppUpdate } from '@/composables/useAppUpdate';

// Detector de deploy novo (singleton: o rodape e o cabecalho mostram o mesmo estado)
const { updateAvailable, recarregar } = useAppUpdate();

const store = useStore();
const router = useRouter();
const route = useRoute();

// Menu Lances visível apenas quando lanceweb = 1 no cadastro do cliente
const showLances = computed(() => store.getters.lanceweb);

// Itens restritos (ex.: Produtos) só aparecem para a empresa ativa liberada
const minhasLicItensVisiveis = computed(() => filtraItensMenu(minhasLicItems, store.getters.cnpjAtivo));

// Breadcrumb gerado a partir do meta da rota atual
const breadcrumbs = computed(() => route.meta?.breadcrumbs ?? []);

let configInterval = null;
let portaisSyncInterval = null; // consulta de segurança dos logins que sincronizam (o normal é atualizar por evento)

const msgAcaoAlerta = ref('');
const msgAcaoPregao = ref('');
const msgAcaoAlertaBNC = ref('');
const msgAcaoAlertaBLL = ref('');
const msgAcaoAlertaLNET = ref('');
const atvSyncPreg = ref(0);
const atvSyncChat = ref(0);
// Badges por portal: BNC = 8, BLL = 5, LicitaNET = 7
const atvSyncChatBNC = ref(0);
const atvSyncChatBLL = ref(0);
const atvSyncChatLNET = ref(0);

// Ações ativas que o header mostra só como mensagem (portal/alerta desativado, falta palavra-chave etc.)
const avisosSync = computed(() => [
    { id: 'pregoes', label: 'Pregões', on: atvSyncPreg.value, texto: msgAcaoPregao.value },
    { id: 'alertas', label: 'Alertas', on: atvSyncChat.value, texto: msgAcaoAlerta.value },
    { id: 'bll', label: 'Alertas BLL', on: atvSyncChatBLL.value, texto: msgAcaoAlertaBLL.value },
    { id: 'bnc', label: 'Alertas BNC', on: atvSyncChatBNC.value, texto: msgAcaoAlertaBNC.value },
    { id: 'lnet', label: 'Alertas LicitaNET', on: atvSyncChatLNET.value, texto: msgAcaoAlertaLNET.value },
].filter((x) => x.on == 1 && x.texto != ''));
const runFds = ref(0);

// NOVOS CAMPOS (GetConfigGeral)
const alertaAtivoCN = ref(1);
const alertaAtivoPCP = ref(1);
const alertaAtivoBNC = ref(1);
const alertaAtivoBLL = ref(1);
const alertaAtivoLNET = ref(1);

const isLoggingOut = ref(false);
const alerta = ref(null);
const inited = ref(false);
const syncStatus = computed(() => store.state.syncDados);
const configsAl = computed(() => store.state.configsAl || []);

// estados derivados
const isLogged = computed(() => store.state.userLogado === true);
const isAuthRoute = computed(() => route.path.startsWith('/auth'));

// ----------------- Helpers -----------------
function getInt(v, def = 0) {
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
}

function isWeekend(d = new Date()) {
    const day = d.getDay(); // 0=domingo, 6=sabado
    return day === 0 || day === 6;
}

// ----------------- Helpers de portais ativos -----------------
const isPortalActive = (id) =>
    Array.isArray(configsAl.value) &&
    configsAl.value.some(p => Number(p.idPortal ?? p.IdPortal) === Number(id) && Number(p.ativo ?? p.Ativo) === 1);

const hasAnyPortalActive = computed(() =>
    Array.isArray(configsAl.value) &&
    configsAl.value.some(p => Number(p.ativo ?? p.Ativo) === 1)
);

// Menu Ajuda → Documentação, Recursos disponíveis e Chat suporte (WhatsApp do suporte com empresa e CNPJ ativos)
const abrirRecursosPortais = () => eventBus.emit('abrir-recursos-portais');
// Menu Ajuda > Documentação: artigo geral da ajuda no EngageFacil (substitui o antigo Zendesk)
const urlDocumentacao = montaUrlAjuda(AJUDA_SLUGS.SISTEMA_MENU_CABECALHO);
const linkAjuda = computed(() => montaLinkAjuda({
    cnpj: store.getters.cnpjAtivo,
    razaoSocial: store.getters.razaoSocialAtiva,
}));

// Portais com login ligado e "sincronizar meus pregões" (independe dos alertas)
const portaisSync = ref([]);
const hasLoginSync = computed(() => Array.isArray(portaisSync.value) && portaisSync.value.length > 0);

async function getPortaisSync() {
    if (!isLogged.value || isAuthRoute.value) return;
    try {
        const json = await listaPortaisQueSincronizam();
        if (json?.ok) {
            portaisSync.value = Array.isArray(json.data) ? json.data : [];
            try {
                const cfg = JSON.parse(localStorage.getItem('configGeral') || '{}');
                applyEffectiveFlags(cfg);
            } catch { }
        }
    } catch (err) {
        console.error('Erro ao obter portais que sincronizam:', err);
    }
}

// Atualiza mensagens quando algum requisito nao e atendido
function updateMsgLabels() {
    msgAcaoPregao.value = '';
    msgAcaoAlerta.value = '';
    msgAcaoAlertaBNC.value = '';
    msgAcaoAlertaBLL.value = '';
    msgAcaoAlertaLNET.value = '';

    if (runFds.value === 0 && isWeekend()) {
        // pregões: se o badge continua montado (login com "sincronizar"), ele mesmo avisa e o botão manual funciona
        msgAcaoPregao.value = atvSyncPreg.value === 1 ? '' : 'Desativado aos finais de semana.';
        msgAcaoAlerta.value = 'Desativado aos finais de semana.';
        msgAcaoAlertaBNC.value = 'Desativado aos finais de semana.';
        msgAcaoAlertaBLL.value = 'Desativado aos finais de semana.';
        msgAcaoAlertaLNET.value = 'Desativado aos finais de semana.';
        return;
    }

    const gateGeraisOff =
        getInt(alertaAtivoCN.value, 1) === 0 &&
        getInt(alertaAtivoPCP.value, 1) === 0;

    if (atvSyncChat.value !== 1) {
        if (gateGeraisOff) msgAcaoAlerta.value = 'Alertas desativados (CN/PCP inativos).';
        else msgAcaoAlerta.value = 'Alertas desativados!';
    } else if (!(isPortalActive(1) || isPortalActive(4) || isPortalActive(2))) {
        msgAcaoAlerta.value = 'Ative o ComprasNet, o PCP ou o Licitações-e para alertas gerais.';
    }

    if (atvSyncChatBNC.value !== 1) {
        if (getInt(alertaAtivoBNC.value, 1) === 0) msgAcaoAlertaBNC.value = 'Alertas BNC desativados (portal inativo).';
        else msgAcaoAlertaBNC.value = 'Alertas BNC desativados!';
    } else if (!isPortalActive(8)) {
        msgAcaoAlertaBNC.value = 'Ative o BNC para alertas BNC.';
    }

    if (atvSyncChatBLL.value !== 1) {
        if (getInt(alertaAtivoBLL.value, 1) === 0) msgAcaoAlertaBLL.value = 'Alertas BLL desativados (portal inativo).';
        else msgAcaoAlertaBLL.value = 'Alertas BLL desativados!';
    } else if (!isPortalActive(5)) {
        msgAcaoAlertaBLL.value = 'Ative o BLL para alertas BLL.';
    }

    if (atvSyncChatLNET.value !== 1) {
        if (getInt(alertaAtivoLNET.value, 1) === 0) msgAcaoAlertaLNET.value = 'Alertas LicitaNET desativados (portal inativo).';
        else msgAcaoAlertaLNET.value = 'Alertas LicitaNET desativados!';
    } else if (!isPortalActive(7)) {
        msgAcaoAlertaLNET.value = 'Ative o LicitaNET para alertas LicitaNET.';
    }
}

// Som/notifications
function showAlertMsg(message) {
    const audioEl = alerta.value;
    if (audioEl) {
        audioEl.currentTime = 0;
        audioEl.play().catch(err => console.error('Erro ao tocar som:', err));
    }
    if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
        new Notification('Novo Alerta!', { body: message, icon: '/images/logo.png' });
    }
}

async function askNotificationPermission() {
    try {
        if (typeof Notification === 'undefined') {
            console.warn('Este navegador não suporta notificações.');
            showAlert('error', 'Este navegador não suporta notificações.');
            return;
        }
        if (Notification.permission === 'default') {
            const permission = await Notification.requestPermission();
            if (permission === 'granted') showAlert('success', 'Permissão de notificação concedida.');
            else showAlert('warning', 'Você bloqueou as notificações.');
        } else if (Notification.permission === 'denied') {
            showAlert('warning', 'Notificações bloqueadas! Ative nas configurações do navegador.');
        }
    } catch (e) {
        console.error('Erro em askNotificationPermission:', e);
    }
}

function toggleMode(mode) {
    window.$appSetting?.toggleMode(mode);
}

function setMenuStyle(style) {
    window.$appSetting.setLayout(style);
}

function isNowWithinTimeSync(timeSyncStr, startOffsetMin = 0, endOffsetMin = 0) {
    if (!timeSyncStr || typeof timeSyncStr !== 'string') return false;
    const parts = timeSyncStr.split('|');
    if (parts.length !== 2) return false;

    const [sh, sm] = (parts[0] || '').trim().split(':').map(n => parseInt(n, 10));
    const [eh, em] = (parts[1] || '').trim().split(':').map(n => parseInt(n, 10));
    if ([sh, sm, eh, em].some(Number.isNaN)) return false;

    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), sh, sm, 0, 0);
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), eh, em, 0, 0);

    if (startOffsetMin) start.setMinutes(start.getMinutes() + startOffsetMin);
    if (endOffsetMin) end.setMinutes(end.getMinutes() + endOffsetMin);

    if (start.getHours() === end.getHours() && start.getMinutes() === end.getMinutes()) return true;

    if (end < start) {
        const endNextDay = new Date(end); endNextDay.setDate(endNextDay.getDate() + 1);
        if (now < start) {
            const startPrevDay = new Date(start); startPrevDay.setDate(startPrevDay.getDate() - 1);
            const endToday = new Date(endNextDay); endToday.setDate(endToday.getDate() - 1);
            return now >= startPrevDay && now <= endToday;
        }
        return now >= start && now <= endNextDay;
    }
    return now >= start && now <= end;
}

/** Aplica flags finais combinando cfg geral + gates do cfg + selecao dos portais */
function applyEffectiveFlags(cfg) {
    // API retorna camelCase — acessar com as chaves exatas do JSON
    runFds.value = getInt(cfg?.runFds, 0);

    // Regra master: fim de semana desliga tudo se runFds = 0
    // Sincronizar pregões "fora do horário": quem marcou "sincronizar meus pregões" no login mantém o badge
    // (o automático do syncpregoes só roda dentro da janela e fora do fim de semana; o botão manual funciona sempre).
    const pregManualFora = getInt(cfg?.atvSyncPreg, 0) === 1 && hasLoginSync.value ? 1 : 0;

    if (runFds.value === 0 && isWeekend()) {
        atvSyncPreg.value = pregManualFora;
        atvSyncChat.value = 0;
        atvSyncChatBNC.value = 0;
        atvSyncChatBLL.value = 0;
        atvSyncChatLNET.value = 0;
        updateMsgLabels();
        return;
    }

    const pregCfg = getInt(cfg?.atvSyncPreg, 0);
    const chatCfg = getInt(cfg?.atvSynChat, 0);
    const dentro = isNowWithinTimeSync(cfg?.timeSync, 0, 0);

    // captura gates do cfg (default=1)
    alertaAtivoCN.value = getInt(cfg?.alertaAtivoCN, 1);
    alertaAtivoPCP.value = getInt(cfg?.alertaAtivoPCP, 1);
    alertaAtivoBNC.value = getInt(cfg?.alertaAtivoBNC, 1);
    alertaAtivoBLL.value = getInt(cfg?.alertaAtivoBLL, 1);
    alertaAtivoLNET.value = getInt(cfg?.alertaAtivoLNET, 1);

    const gateGeraisOff =
        alertaAtivoCN.value === 0 &&
        alertaAtivoPCP.value === 0;

    if (!dentro) {
        atvSyncPreg.value = pregManualFora;
        atvSyncChat.value = 0;
        atvSyncChatBNC.value = 0;
        atvSyncChatBLL.value = 0;
        atvSyncChatLNET.value = 0;
        updateMsgLabels();
        return;
    }

    // 1) PREGOES: independe dos alertas. Chave mestre da ADM (swatvsyncpreg) + algum portal
    //    ativo nos alertas OU algum login com "sincronizar meus pregões" ligado.
    //    As chaves swalertaativo* (gates de alerta) não desligam mais a sincronização de pregões.
    atvSyncPreg.value = (pregCfg === 1 && (hasAnyPortalActive.value || hasLoginSync.value)) ? 1 : 0;

    // 2) ALERTAS GERAIS: se CN e PCP gates = 0, desliga
    if (gateGeraisOff) {
        atvSyncChat.value = 0;
    } else {
        // Alertas gerais = ComprasNet (1), PCP (4), Licitações-e legado (2) e LicitaNET (7): leem o chat central (tabela chat do DADOS)
        atvSyncChat.value = (chatCfg === 1 && (isPortalActive(1) || isPortalActive(4) || isPortalActive(2) || isPortalActive(7))) ? 1 : 0;
    }

    // 3) ALERTAS BNC (portal 8): se gate BNC = 0, desliga
    if (alertaAtivoBNC.value === 0) {
        atvSyncChatBNC.value = 0;
    } else {
        atvSyncChatBNC.value = (chatCfg === 1 && isPortalActive(8)) ? 1 : 0;
    }

    // 4) ALERTAS BLL (portal 5): se gate BLL = 0, desliga
    if (alertaAtivoBLL.value === 0) {
        atvSyncChatBLL.value = 0;
    } else {
        atvSyncChatBLL.value = (chatCfg === 1 && isPortalActive(5)) ? 1 : 0;
    }

    // 5) ALERTAS LICITANET (portal 7): se gate LicitaNET = 0, desliga
    if (alertaAtivoLNET.value === 0) {
        atvSyncChatLNET.value = 0;
    } else {
        atvSyncChatLNET.value = (chatCfg === 1 && isPortalActive(7)) ? 1 : 0;
    }

    updateMsgLabels();
}

/** Busca config geral e aplica flags considerando selecao dos portais */
async function getConfigGeral() {
    if (!isLogged.value || isAuthRoute.value) return;
    try {
        // Multi-CNPJ: heartbeat e config geral no contexto da empresa ativa
        const payload = heartbeatData(getCnpjAtivo());

        const json = await getConfigGeralApi(payload);
        if (json?.ok) {
            const cfg = json.data ?? {};
            localStorage.setItem('configGeral', JSON.stringify(cfg));
            applyEffectiveFlags(cfg);
        }
    } catch (err) {
        console.error('Erro ao obter configGeral:', err);
        atvSyncPreg.value = 0;
        atvSyncChat.value = 0;
        atvSyncChatBNC.value = 0;
        atvSyncChatBLL.value = 0;
        atvSyncChatLNET.value = 0;
        updateMsgLabels();
    }
}

async function getDadosIni() {
    if (!isLogged.value || isAuthRoute.value) return;
    try {
        const json = await getDadosIniciais();
        if (json?.ok) {
            store.commit('changeSyncDados', JSON.parse(json.data));
        }
    } catch (err) {
        console.error('Erro ao obter dados iniciais:', err);
    }
}

async function getConfigAlertas() {
    if (!isLogged.value || isAuthRoute.value) return;
    try {
        const json = await listaConfigAlerta('geral.portais.alertas');
        if (json?.ok) {
            store.commit('changeConfigsAl', json.data);
            try {
                const cfg = JSON.parse(localStorage.getItem('configGeral') || '{}');
                applyEffectiveFlags(cfg);
            } catch { }
        }
    } catch (err) {
        console.error('Erro ao obter dados getConfigAlertas:', err);
    }
}

async function initHeaderOnce() {
    if (inited.value) return;
    if (!isLogged.value || isAuthRoute.value) return;
    inited.value = true;

    try {
        // 1) Portais selecionados
        await getConfigAlertas();

        // 1b) Portais com login que sincroniza os pregões (independe dos alertas)
        await getPortaisSync();

        // 2) Config geral + janelas de tempo
        await getConfigGeral();
        configInterval = setInterval(getConfigGeral, 60_000);
        // Logins que sincronizam mudam raramente: o cabeçalho é avisado por evento ao salvar/excluir um login;
        // esta consulta só cobre alteração feita em outra aba/dispositivo.
        portaisSyncInterval = setInterval(getPortaisSync, 10 * 60_000);

        // 3) Dados iniciais
        await getDadosIni();

        const licencas = Array.isArray(store.state.userDados?.licencas)
            ? store.state.userDados.licencas
            : [];

        let licAlertaOK = useLicencaTipo('alerta', licencas);

        // verificação para alertas dispensa CN
        if (!licAlertaOK) {
            licAlertaOK = useLicencaTipo('dispensa', licencas);
        }

        if (!licAlertaOK) {
            msgAcaoAlerta.value = 'Alertas desativados!';
            // A mensagem de pregões NÃO depende da licença de alerta: quem decide é applyEffectiveFlags/updateMsgLabels
            msgAcaoAlertaBNC.value = 'Alertas desativados!';
            msgAcaoAlertaBLL.value = 'Alertas desativados!';
            msgAcaoAlertaLNET.value = 'Alertas desativados!';
        } else {
            const json = await listaPlsAlertas();
            if (json?.data?.length <= 0) {
                msgAcaoAlerta.value = 'Configure as palavras chaves';
                msgAcaoAlertaBNC.value = 'Configure as palavras chaves';
                msgAcaoAlertaBLL.value = 'Configure as palavras chaves';
                msgAcaoAlertaLNET.value = 'Configure as palavras chaves';
            }
        }

        toggleMode();
    } catch (e) {
        console.error('Falha no initHeaderOnce:', e);
    }
}

onMounted(async () => {
    askNotificationPermission().catch(console.error);
    eventBus.on('play-alert', showAlertMsg);
    eventBus.on('logins-portais-atualizados', getPortaisSync);

    if (isLogged.value && !isAuthRoute.value) initHeaderOnce();

    // Recalcular flags sempre que a selecao de portais mudar
    watch(configsAl, () => {
        try {
            const cfg = JSON.parse(localStorage.getItem('configGeral') || '{}');
            applyEffectiveFlags(cfg);
        } catch { }
    }, { deep: true });

    watch(portaisSync, () => {
        try {
            const cfg = JSON.parse(localStorage.getItem('configGeral') || '{}');
            applyEffectiveFlags(cfg);
        } catch { }
    }, { deep: true });

    watch([isLogged, () => route.path], ([logged]) => {
        if (logged && !isAuthRoute.value) {
            initHeaderOnce();
        } else {
            if (configInterval) { clearInterval(configInterval); configInterval = null; }
            if (portaisSyncInterval) { clearInterval(portaisSyncInterval); portaisSyncInterval = null; }
        }
    });
});

onUnmounted(() => {
    if (configInterval) clearInterval(configInterval);
    if (portaisSyncInterval) clearInterval(portaisSyncInterval);
    eventBus.off('play-alert', showAlertMsg);
    eventBus.off('logins-portais-atualizados', getPortaisSync);
});

function goAlertas() { router.push('/apps/alertas'); }
function navegaBuscaOrFav(bFav) {
    store.commit('changeBuscaFavorito', bFav);
    router.push('/apps/busca');
}
function trancaTela() {
    store.commit('changeTelaTrancada', true);
    // Vai direto para a tela de bloqueio (antes só marcava e a tela abria apenas ao trocar de página)
    router.push('/auth/lockscreen-boxed');
}

// Logout direto: limpa store + vai pro login (sem passar por /auth/logout)
const lofogUser = async () => {
    if (isLoggingOut.value) return;
    isLoggingOut.value = true;

    try { sessionStorage.removeItem('tabId'); } catch { }
    try { localStorage.removeItem('masterTabId'); } catch { }
    try { localStorage.removeItem('primaryTabClaimed'); } catch { }
    try { store.commit('setEmpresaAtiva', null); } catch { }

    store.commit('changeTelaTrancada', false);
    store.commit('changeUserLogado', false);
    store.commit('changeUserDados', null);

    if (configInterval) { clearInterval(configInterval); configInterval = null; }
    if (portaisSyncInterval) { clearInterval(portaisSyncInterval); portaisSyncInterval = null; }
    eventBus.off('play-alert', showAlertMsg);
    eventBus.off('logins-portais-atualizados', getPortaisSync);

    try { store.commit('setLayout', 'auth'); } catch { }

    const { href } = router.resolve({ name: 'login-boxed' });
    window.location.replace(href);
};
</script>
